module.exports = __webpack_public_path__ + "media/newstyle/images/cta-desktop-52c18ae9b2f3fd550a2d77499381883c.png";